// src/containers/Codes/usageCodes.js

import CodeSet from './CodeSet';

const usageCodes = new CodeSet('usage', { fr: 'utilisation', it: 'uso', es: 'uso' });

// Interior
usageCodes.addData(0, {
  name: { en: 'interior', fr: 'intérieur', it: 'interno', es: 'interior' },
  text: { en: '', fr: '', it: '', es: '' }
});

// Outdoor
usageCodes.addData(1, {
  name: { en: 'outdoor', fr: 'extérieur', it: 'esterno', es: 'exterior' },
  text: { en: 'Enjoy the outdoors in style with our durable and weather-resistant outdoor rugs.', fr: '', it: '', es: '' }
});

// Children
usageCodes.addData(2, {
  name: { en: 'children', fr: 'enfants', it: 'bambini', es: 'niños' },
  text: { en: 'Spark imagination with fun and playful kids\' rugs that are both stylish and practical.', fr: '', it: '', es: '' }
});

// Kitchen
usageCodes.addData(3, {
  name: { en: 'kitchen', fr: 'cuisine', it: 'cucina', es: 'cocina' },
  text: { en: '', fr: '', it: '', es: '' }
});

// Fireplace
usageCodes.addData(4, {
  name: { en: 'fireplace', fr: 'cheminée', it: 'caminetto', es: 'chimenea' },
  text: { en: '', fr: '', it: '', es: '' }
});

// Prayer
usageCodes.addData(5, {
  name: { en: 'prayer', fr: 'prière', it: 'preghiera', es: 'rezo' },
  text: { en: '', fr: '', it: '', es: '' }
});


export default usageCodes;
